import { Tooltip } from '@blueprintjs/core';
import styles from './Reason.module.css';
import { lender_filter_result } from '@axo/shared/data-access/types';

interface ReasonProps {
  lenderStatus: string;
  width?: string;
  lenderFilterResult: lender_filter_result.LenderFilterResult[];
}

export function Reason({
  lenderStatus,
  width,
  lenderFilterResult,
}: ReasonProps) {
  const getStatusText = () => {
    if (!lenderStatus && lenderFilterResult.length === 0) return null;

    const filterResults = lenderFilterResult
      .map((filterResult) => {
        return filterResult.Result;
      })
      .join(', ');

    return (
      <div className={styles.truncate}>
        {`${lenderStatus}${
          lenderStatus && lenderFilterResult.length ? ', ' : ''
        }${filterResults}`}
      </div>
    );
  };

  const tooltipContent = (
    <>
      {lenderFilterResult.length > 0 && (
        <div>
          {lenderFilterResult.map((filterResult) => (
            <div key={filterResult.ID} className={styles.capitalize}>
              {filterResult.Result}
            </div>
          ))}
        </div>
      )}
      {lenderStatus && (
        <div>
          <span className={styles.capitalize}>{lenderStatus}</span>
        </div>
      )}
    </>
  );

  return (
    <Tooltip
      disabled={!getStatusText()}
      content={tooltipContent}
      placement="bottom"
      renderTarget={({ isOpen: _, ...targetProps }) => (
        <div data-variant={width} {...targetProps}>
          {getStatusText() ?? '-'}
        </div>
      )}
    />
  );
}
